import { ProgramaCheckedAno } from 'models/escola';
import {
  LoadedCoopEscola,
  LoadedTipoDocumento,
} from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/listaPrograma/listaPeriodo/listaPeriodoItem/cooperativa/Modal/ModalAddCoop/DocumentCoop/__types';
import {
  EscolaEditTabs,
} from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/__enum';
import {
  CHANGE_ESCOLA_STATUS_ACTION,
  CHANGED_ESCOLA_EDITING_VALUE_ACTION,
  CHANGED_IDEB_EDITING_VALUE_ACTION,
  CHANGED_PERIODO_EDITING_VALUE_ACTION,
  CHANGED_PERIODO_EDITING_VALUE_COOP_ACTION,
  CHANGED_PERIODO_EDITING_VALUE_FINANCAS_ACTION,
  CLEAR_FORM_DATA,
  CLEAR_SELECTED_CHECKBOXES,
  CLEARED_ALL_IDEB_ACTION,
  CLEARED_ESCOLA_ACTION,
  CLEARED_ESCOLAS_PAGE_ACTION,
  CLEARED_IDEB_ACTION,
  CLEARED_PERIODO_ACTION,
  CLEARED_PERIODO_COOP_ACTION,
  CLEARED_PERIODO_FINANCAS_ACTION,
  CLOSE_MODAL,
  HANDLE_BACK,
  HANDLE_CHANGE_PROGRAMA_STATUS_ACTION,
  HANDLE_NEXT,
  LOADED_ALL_ESCOLAS_BY_LIST_CIDADE_ID,
  LOADED_ALL_IDEBS_ACTION,
  LOADED_ALL_PERIODOS_ACTION,
  LOADED_ASSESSOR_DATA,
  LOADED_COOPS_ESCOLAR_ACTION,
  LOADED_DADOS_DA_ESCOLA_ACTION,
  LOADED_DADOS_DA_ESCOLA_COOP_ACTION,
  LOADED_DADOS_DA_ESCOLA_FINANCAS_ACTION,
  LOADED_ESCOLA_ACTION,
  LOADED_ESCOLAS_ACTION,
  LOADED_ESCOLAS_BY_COOPS_ACTION,
  LOADED_ESCOLAS_PAGE_ACTION,
  LOADED_ESCOLAS_POR_CIDADE_ACTION,
  LOADED_ESCOLAS_POR_CIDADES_COOP_ACTION,
  LOADED_ESCOLAS_POR_ESTADO_CIDADE_ACTION,
  LOADED_ETAPAS_ENSINO_ACTION,
  LOADED_IDEB_ACTION,
  LOADED_MODALIDADES_ACTION,
  LOADED_PERIODO_ACTION,
  LOADED_PERIODO_COOP_ACTION,
  LOADED_PERIODO_FINANCAS_ACTION,
  LOADED_PERIODOS_ACTION,
  LOADED_PERIODOS_COOP_ACTION,
  LOADED_PERIODOS_FINANCAS_ACTION,
  LOADED_PRINCIPIO_VALOR_ACTION,
  LOADED_PROGRAMA_INFO_ACTION,
  LOADED_PROGRAMAS_ACTION,
  LOADED_TIPO_DOCUMENTO_ACTION,
  LOADING_MODALIDADES_ACTION,
  LOADING_PERIODOS_ACTION,
  LOADING_PERIODOS_COOP_ACTION,
  LOADING_PERIODOS_FINANCAS_ACTION,
  LOADING_PROGRAMAS_ACTION,
  OPEN_MODAL,
  REMOVED_PERIODO_ACTION,
  REMOVED_PERIODO_FINANCAS_ACTION,
  RESET_PROGRAMA_VALUE,
  RESETED_ESCOLAS,
  SAVING_COOP_ESCOLAR,
  SET_CURRENT_TAB,
  SET_CURRENT_TAB_PROGRAMA,
  SET_ENVIAR_FORMULARIO_PERIODO,
  SUBMIT_COOP_DATA_FAILURE,
  SUBMIT_COOP_DATA_SUCCESS,
  UPDATE_FORM_DATA,
  UPDATE_FORM_DATA_ADD_COOP,
  UPDATE_PROGRAMA_VALUE,
} from './EscolasActions';
import { ProgramasResponse } from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/__types';

export type Action<T, P> = {
  type: T;
  payload: P;
};

export type ChangeEscolaStatusAction = Action<
  typeof CHANGE_ESCOLA_STATUS_ACTION,
  { id: string; status: string }
>;
export type ChangedEscolaEditingValueAction = Action<
  typeof CHANGED_ESCOLA_EDITING_VALUE_ACTION,
  { name: string; value: string }
>;
export type ChangedIdebEditingValueAction = Action<
  typeof CHANGED_IDEB_EDITING_VALUE_ACTION,
  { name: string; value: string }
>;

export type LoadedAssessorDataAction = {
  type: typeof LOADED_ASSESSOR_DATA;
  payload: AssessorData;
};

export type ChangedPeriodoEditingValueAction = Action<
  typeof CHANGED_PERIODO_EDITING_VALUE_ACTION,
  { name: string; value: string }
>;

export type ChangedPeriodoEditingValueCoopAction = Action<
  typeof CHANGED_PERIODO_EDITING_VALUE_COOP_ACTION,
  { name: string; value: string }
>;

export type ChangedPeriodoEditingValueFinancasAction = Action<
  typeof CHANGED_PERIODO_EDITING_VALUE_FINANCAS_ACTION,
  { name: string; value: string }
>;
export type ClearFormDataAction = Action<typeof CLEAR_FORM_DATA, string>;
export type ClearedAllIdebAction = Action<typeof CLEARED_ALL_IDEB_ACTION, null>;
export type ClearedEscolaAction = Action<typeof CLEARED_ESCOLA_ACTION, null>;
export type ClearedEscolasPageAction = Action<
  typeof CLEARED_ESCOLAS_PAGE_ACTION,
  { type: string }
>;
export type ClearedIdebAction = Action<typeof CLEARED_IDEB_ACTION, null>;
export type ClearedPeriodoAction = Action<typeof CLEARED_PERIODO_ACTION, null>;
export type ClearedPeriodoCoopAction = Action<
  typeof CLEARED_PERIODO_COOP_ACTION,
  null
>;
export type ClearedPeriodoFinancasAction = Action<
  typeof CLEARED_PERIODO_FINANCAS_ACTION,
  null
>;
export type CloseModalAction = Action<typeof CLOSE_MODAL, null>;
export type HandleBackAction = Action<typeof HANDLE_BACK, null>;
export type HandleNextAction = Action<typeof HANDLE_NEXT, null>;

export type LoadDadosDaEscolaAction = Action<
  typeof LOADED_DADOS_DA_ESCOLA_ACTION,
  {
    dadosDaEscola: string[];
    pagePeriodoEscola: {
      page: number;
      totalElements: number;
      totalPages: number;
      elements: string[];
    };
  }
>;

export type LoadDadosDaEscolaCoopAction = Action<
  typeof LOADED_DADOS_DA_ESCOLA_COOP_ACTION,
  {
    dadosDaEscola: string[], pagePeriodoEscola: {
      page: number;
      totalElements: number;
      totalPages: number;
      elements: string[];
    };
  }
>;

export type LoadDadosDaEscolaFinancasAction = Action<
  typeof LOADED_DADOS_DA_ESCOLA_FINANCAS_ACTION,
  {
    dadosDaEscola: string[], pagePeriodoEscola: {
      page: number;
      totalElements: number;
      totalPages: number;
      elements: string[];
    };
  }
>;

export type LoadEscolasAction = Action<typeof LOADED_ESCOLAS_ACTION, boolean[]>;
export type LoadEscolasByCoopsAction = Action<
  typeof LOADED_ESCOLAS_BY_COOPS_ACTION,
  string[]
>;
export type LoadedCoopsEscolarAction = Action<
  typeof LOADED_COOPS_ESCOLAR_ACTION,
  LoadedCoopEscola[]
>;
export type LoadedTipoDocumentoAction = Action<
  typeof LOADED_TIPO_DOCUMENTO_ACTION,
  LoadedTipoDocumento[]
>;
export type SavingCoopEscolar = Action<typeof SAVING_COOP_ESCOLAR, boolean>;
export type LoadEscolasPageAction = Action<
  typeof LOADED_ESCOLAS_PAGE_ACTION,
  {
    filtro: string;
    page: number;
    totalElements: number;
    totalPages: number;
    elements: string[];
  }
>;
export type LoadEscolasPorCidadeAction = Action<
  typeof LOADED_ESCOLAS_POR_CIDADE_ACTION,
  string[]
>;
export type LoadEscolasPorCidadesCoopAction = Action<
  typeof LOADED_ESCOLAS_POR_CIDADES_COOP_ACTION,
  string[]
>;
export type LoadEscolasPorCooperativaEstadoCidadeAction = Action<
  typeof LOADED_ESCOLAS_POR_ESTADO_CIDADE_ACTION,
  string[]
>;
export type LoadEtapasEnsinoAction = Action<
  typeof LOADED_ETAPAS_ENSINO_ACTION,
  string[]
>;
export type LoadPrincipioValorAction = Action<
  typeof LOADED_PRINCIPIO_VALOR_ACTION,
  string[]
>;
export type LoadedAllEscolasByListCidadeIdAction = Action<
  typeof LOADED_ALL_ESCOLAS_BY_LIST_CIDADE_ID,
  string[]
>;
export type LoadedAllIdebsAction = Action<
  typeof LOADED_ALL_IDEBS_ACTION,
  string[]
>;
export type LoadedAllPeriodosAction = Action<
  typeof LOADED_ALL_PERIODOS_ACTION,
  { nomPeriodo: string | undefined }[]
>;
export type LoadedIdebAction = Action<typeof LOADED_IDEB_ACTION, any>;
export type LoadedPeriodoAction = Action<typeof LOADED_PERIODO_ACTION, any>;
export type LoadedPeriodoCoopAction = Action<
  typeof LOADED_PERIODO_COOP_ACTION,
  any
>;

export type LoadedPeriodoFinancasAction = Action<
  typeof LOADED_PERIODO_FINANCAS_ACTION,
  any
>;
export type RemovedPeriodoAction = Action<
  typeof REMOVED_PERIODO_ACTION,
  { idEscola: string; periodo: string }
>;

export type RemovedPeriodoFinancasAction = Action<
  typeof REMOVED_PERIODO_FINANCAS_ACTION,
  { idEscola: string }
>;
export type OpenModalAction = Action<typeof OPEN_MODAL, null>;
export type LoadedEscolaAction = Action<typeof LOADED_ESCOLA_ACTION, any>;
export type ResetEscolasAction = Action<typeof RESETED_ESCOLAS, null>;
export type SetCurrentIndexAction = Action<
  typeof SET_CURRENT_TAB,
  EscolaEditTabs
>;

export type UpdateFormDataAction = Action<
  typeof UPDATE_FORM_DATA,
  { tabName: string; data: string }
>;

export type UpdateFormDataAddCoop = Action<
  typeof UPDATE_FORM_DATA_ADD_COOP,
  { name: string; value: string }
>;
export type LoadingModalidadesEscolar = Action<
  typeof LOADING_MODALIDADES_ACTION,
  boolean
>;
export type LoadedModalidadesEscolar = Action<
  typeof LOADED_MODALIDADES_ACTION,
  string[]
>;
export type LoadedProgramasEscolar = Action<
  typeof LOADED_PROGRAMAS_ACTION,
  any
>;
export type LoadedProgramaInfoAction = Action<
  typeof LOADED_PROGRAMA_INFO_ACTION,
  ProgramasResponse
>;
export type LoadingProgramasEscolar = Action<
  typeof LOADING_PROGRAMAS_ACTION,
  boolean
>;
export type SubmitCoopDataSuccess = Action<
  typeof SUBMIT_COOP_DATA_SUCCESS,
  null
>;
export type SubmitCoopDataFailure = Action<
  typeof SUBMIT_COOP_DATA_FAILURE,
  null
>;
export type LoadedPeriodosAction = Action<typeof LOADED_PERIODOS_ACTION, any>;
export type LoadedPeriodosCoopAction = Action<
  typeof LOADED_PERIODOS_COOP_ACTION,
  any
>;
export type LoadedPeriodosFinancasAction = Action<
  typeof LOADED_PERIODOS_FINANCAS_ACTION,
  any
>;
export type LoadingPeriodosFinancasAction = Action<
  typeof LOADING_PERIODOS_FINANCAS_ACTION,
  any
>;
export type LoadingPeriodosAction = Action<
  typeof LOADING_PERIODOS_ACTION,
  boolean
>;
export type LoadingPeriodosCoopAction = Action<
  typeof LOADING_PERIODOS_COOP_ACTION,
  boolean
>;
export type HandleProgramaStatusChangeAction = Action<
  typeof HANDLE_CHANGE_PROGRAMA_STATUS_ACTION,
  {
    tipoPrograma: TipoPrograma;
    status: boolean;
  }
>;
export type clearSelectedCheckboxes = Action<
  typeof CLEAR_SELECTED_CHECKBOXES,
  null
>;
export type UpdateProgramaValueAction = Action<
  typeof UPDATE_PROGRAMA_VALUE,
  { tipo: TipoPrograma; value: Partial<ProgramaCheckedAno> }
>;
export type ResetProgramaValueAction = Action<typeof RESET_PROGRAMA_VALUE, null>;

export type SetCurrentTabProgramaAction = Action<
  typeof SET_CURRENT_TAB_PROGRAMA,
  string
>;

export interface SetEnviarFormularioPeriodoAction {
  type: typeof SET_ENVIAR_FORMULARIO_PERIODO;
  payload: boolean;
}

export type EscolasAction =
  | ResetEscolasAction
  | SetEnviarFormularioPeriodoAction
  | ResetProgramaValueAction
  | LoadedPeriodosCoopAction
  | RemovedPeriodoFinancasAction
  | LoadedPeriodosFinancasAction
  | ClearedPeriodoFinancasAction
  | ChangedPeriodoEditingValueFinancasAction
  | LoadingPeriodosFinancasAction
  | SubmitCoopDataSuccess
  | SubmitCoopDataFailure
  | LoadedAssessorDataAction
  | LoadedModalidadesEscolar
  | ChangedPeriodoEditingValueCoopAction
  | LoadingPeriodosAction
  | LoadedPeriodoCoopAction
  | LoadedPeriodoFinancasAction
  | LoadedPeriodosAction
  | LoadingModalidadesEscolar
  | LoadingProgramasEscolar
  | LoadingPeriodosCoopAction
  | LoadedProgramasEscolar
  | ClearedPeriodoCoopAction
  | UpdateProgramaValueAction
  | clearSelectedCheckboxes
  | UpdateFormDataAddCoop
  | LoadDadosDaEscolaAction
  | LoadDadosDaEscolaCoopAction
  | LoadDadosDaEscolaFinancasAction
  | LoadEscolasByCoopsAction
  | ClearedEscolasPageAction
  | LoadEscolasAction
  | LoadEscolasPorCidadeAction
  | LoadEscolasPorCooperativaEstadoCidadeAction
  | LoadEscolasPorCidadesCoopAction
  | SavingCoopEscolar
  | ChangeEscolaStatusAction
  | LoadEtapasEnsinoAction
  | LoadPrincipioValorAction
  | LoadEscolasPageAction
  | ChangedPeriodoEditingValueAction
  | ChangedIdebEditingValueAction
  | ClearedAllIdebAction
  | ClearedPeriodoAction
  | LoadedPeriodoAction
  | RemovedPeriodoAction
  | LoadedAllPeriodosAction
  | LoadedIdebAction
  | LoadedAllIdebsAction
  | ChangedEscolaEditingValueAction
  | ClearedEscolaAction
  | ClearedIdebAction
  | LoadedEscolaAction
  | LoadedAllEscolasByListCidadeIdAction
  | SetCurrentIndexAction
  | HandleNextAction
  | HandleBackAction
  | OpenModalAction
  | CloseModalAction
  | UpdateFormDataAction
  | ClearFormDataAction
  | LoadedCoopsEscolarAction
  | LoadedTipoDocumentoAction
  | LoadedProgramaInfoAction
  | HandleProgramaStatusChangeAction
  | SetCurrentTabProgramaAction
export interface Programa {
  tipoPrograma: number;
  anoImplementacao: number;
}

export enum TipoPrograma {
  UniaoFazAVida = '0',
  CooperativaEscolar = '1',
  FinancasNaMochila = '2',
}

export const tipos: TipoPrograma[] = [
  TipoPrograma.UniaoFazAVida,
  TipoPrograma.CooperativaEscolar,
  TipoPrograma.FinancasNaMochila,
];

export const tipoProgramaMap = {
  uniaoFazAVida: TipoPrograma.UniaoFazAVida,
  cooperativaEscolar: TipoPrograma.CooperativaEscolar,
  financasNaMochila: TipoPrograma.FinancasNaMochila,
};
export interface AssessorData {
  nome: string;
  celular: string;
  email: string;
  cpf: string;
  idEmpresa: number | null;
  cooperativas: string[];
  formacaoAcademica: number | null;
  areaEstudo: string;
  cooperativasGestor: string[];
  dataNascimento: string;
  programasEducacionais: number[];
}

